<template>
    <div>
        <v-list v-for="type in types" :key="type">
            <v-subheader class="px-4">
                {{ $t('enums.organisation_type.' + type).toUpperCase() }}
            </v-subheader>

            <template v-if="type === 'ADVISER'">
                <v-list-item-group
                    v-for="(item, index) in items.filter(i => i.type === 'ADVISER')"
                    :key="index"
                    :value="Auth().organisation_id"
                    color="primaryText"
                >
                    <v-list-item
                        :value="item.organisation.id"
                        :inactive="Auth().organisation_id === item.organisation.id"
                        :disabled="Auth().organisation_id === item.organisation.id"
                        color="primaryText"
                        @click.stop="onClick(item)"
                    >
                        <v-list-item-avatar color="background" size="32" class="justify-center">
                            <v-img contain max-height="30" max-width="30" :src="item.avatar" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <div class="caption grey--text text--darken-2">{{ item.caption }}</div>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.locked">
                            <v-icon small>{{ getIcon('lock') }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-action v-if="Auth().is_adviser && Auth().organisation_id === item.organisation.id">
                            <v-icon color="success" small>{{ getIcon('success') }}</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </template>

            <template v-if="type === 'INVESTOR'">
                <v-list-item-group
                    v-for="(item, index) in items.filter(i => i.type === 'INVESTOR')"
                    :key="index"
                    :value="`${Auth().organisation_id}_${Auth().account_id}`"
                    color="primaryText"
                >
                    <v-list-item
                        :value="`${item.organisation.id}_${item.account.adviser_id}`"
                        :inactive="
                            Auth().organisation_id === item.organisation.id &&
                            Auth().account_id === item.account.adviser_id
                        "
                        :disabled="
                            Auth().organisation_id === item.organisation.id &&
                            Auth().account_id === item.account.adviser_id
                        "
                        color="primaryText"
                        @click.stop="onClick(item)"
                    >
                        <v-list-item-avatar color="background" size="32" class="justify-center">
                            <v-img contain max-height="30" max-width="30" :src="item.avatar" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                <div>{{ item.name }}</div>
                                <div class="caption grey--text text--darken-2">{{ item.caption }}</div>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.locked">
                            <v-icon small>{{ getIcon('lock') }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-action
                            v-if="
                                Auth().is_investor &&
                                Auth().is_initialised &&
                                Auth().adviser_id === item.account.adviser_id &&
                                Auth().organisation_id === item.organisation.id
                            "
                        >
                            <v-icon color="success" small>{{ getIcon('success') }}</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </template>

            <template v-if="type === 'PRODUCT_PROVIDER'">
                <v-list-item-group
                    v-for="(item, index) in items.filter(i => i.type === 'PRODUCT_PROVIDER')"
                    :key="index"
                    :value="Auth().organisation_id"
                    color="primaryText"
                >
                    <v-list-item
                        :value="item.organisation.id"
                        :inactive="Auth().organisation_id === item.organisation.id"
                        :disabled="Auth().organisation_id === item.organisation.id"
                        color="primaryText"
                        @click.stop="onClick(item)"
                    >
                        <v-list-item-avatar color="background" size="32" class="justify-center">
                            <v-img contain max-height="30" max-width="30" :src="item.avatar" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <div class="caption grey--text text--darken-2">{{ item.caption }}</div>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.locked">
                            <v-icon small>{{ getIcon('lock') }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-action
                            v-if="Auth().is_provider && Auth().organisation_id === item.organisation.id"
                        >
                            <v-icon color="success" small>{{ getIcon('success') }}</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </template>

            <template v-if="type === 'COMPANY'">
                <v-list-item-group
                    v-for="(item, index) in items.filter(i => i.type === 'COMPANY')"
                    :key="index"
                    :value="Auth().organisation_id"
                    color="primaryText"
                >
                    <v-list-item
                        :value="item.organisation.id"
                        :inactive="Auth().organisation_id === item.organisation.id"
                        :disabled="Auth().organisation_id === item.organisation.id"
                        color="primaryText"
                        @click.stop="onClick(item)"
                    >
                        <v-list-item-avatar color="background" size="32" class="justify-center">
                            <v-img contain max-height="30" max-width="30" :src="item.avatar" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <div class="caption grey--text text--darken-2">{{ item.caption }}</div>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.locked">
                            <v-icon small>{{ getIcon('lock') }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-action
                            v-if="Auth().is_provider && Auth().organisation_id === item.organisation.id"
                        >
                            <v-icon color="success" small>{{ getIcon('success') }}</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </template>
        </v-list>
    </div>
</template>

<script>
import { changeContext, changeLogin } from '@/lib/auth';
import { Branding } from '@/models';

export default {
    name: 'AppAccountSwitcherList',
    computed: {
        types() {
            return this.Auth()
                .organisations.map(org => org.type)
                .filter((type, index, self) => self.indexOf(type) === index)
                .sort((a, b) => a.localeCompare(b));
        },
        items() {
            const items = [];

            const unlocked = this.Auth().user.organisations.map(org => org.id);

            for (const org of this.Auth().organisations) {
                if ('accounts' in org) {
                    for (const acc of org.accounts) {
                        const branding = Branding.find(acc.adviser_id);
                        items.push({
                            name: acc.adviser_name,
                            caption: org.name,
                            type: org.type,
                            avatar: branding ? branding.image('avatar') : null,
                            organisation: org,
                            account: acc,
                            locked: !unlocked.includes(org.id)
                        });
                    }
                } else {
                    const branding = Branding.find(org.id);
                    items.push({
                        name: org.name,
                        caption: '',
                        type: org.type,
                        avatar: branding ? branding.image('avatar') : null,
                        organisation: org,
                        account: null,
                        locked: !unlocked.includes(org.id)
                    });
                }
            }

            return items;
        }
    },
    methods: {
        onClick(item) {
            if (item.locked) {
                for (const user of this.Auth().linked_users) {
                    if (user.organisations.find(lu => lu.id === item.organisation.id)) {
                        changeLogin(user, item.organisation, item.account);
                    }
                }
            } else if (
                item.organisation !== this.Auth().organisation ||
                !this.Auth().account ||
                item.account.adviser_id !== this.Auth().account_id
            ) {
                changeContext(item.organisation, item.account);
            }
        }
    }
};
</script>
